<template>
  <div class="retail-order-list">
    <orderDetail @backAndClose='backAndClose' v-if="orderDetailShow" :orderNo='orderNoDetail'></orderDetail>
    <div class="app-container calendar-list-container" v-else>
      <div class="title">订单中心</div>
        <el-divider></el-divider>
      <!-- 状态切换区 -->
      <div class="nav-box">
        <ul>
          <li v-for="(item, index) in navList" :key="index" :class="[tabPage === index ? 'active':'']" @click="handleTabPage(index)">{{ item.label }}</li>
        </ul>
        <el-button class="after-sale-btn" @click="handleToAfterSale">售后处理</el-button>
      </div>
      <!-- 列表 -->
      <ul class="mt10" v-if="orderList.length > 0">
        <li class="flex-between order-item" v-for="(item, index) in orderList" :key="index">
          <div class="pic flex-align-center">
            <img v-if="item.mainPic" class="order-img" :src="item.mainPic" alt="">
            <img v-else class="order-img" src="../../assets/images/default_img.jpg" alt="">
          </div>
          <div class="order-item-info">
            <div class="title-time">
              <h4 class="order-title" @click="handleToDetail(item.uniteOrderNo)">{{item.merchIndustryName}}</h4>
              <span class="lable">下单时间:</span>
              <span class="lable-value">{{item.crtTime}}</span>
            </div>
            <div class="flex-align-center">
              <div class="goods-name flex-1">{{item.goodsName}}</div>
              <div class="num flex-1">数量：<span>{{item.quantity}}</span></div>
              <div class="order-pay">实付款: ¥{{item.paymentTotal}}
                <span v-if="item.payTypeName">({{item.payTypeName}})</span>
              </div>
              <p class="order-status flex-2">
                <span>{{item.statusName}}</span>
                <a v-if="item.status === 0" class="order-btn" @click="handleToPay(item)">支付</a>
                <!-- 已发货（部分发货7，待收货10）和已收货28的订单显示物流信息按钮 -->
                <a v-if="item.status === 7 || item.status === 10 || item.status === 28" class="order-btn" @click="handleToShipping(item.uniteOrderNo)">物流信息</a>
              </p>
            </div>
          </div>
        </li>
      </ul>
      <div v-else class="no-data">暂无数据</div>
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page"
          :page-sizes="[10,20,30]"
          :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
        ></el-pagination>
      </div>
      <!-- 支付弹框 -->
      <payDialog ref="payDialog" :from="from" />
      <!-- 物流弹窗 -->
      <el-dialog
        :visible.sync="dialogVisible"
        width="1050px"
        append-to-body
        center
        :show-close="false">
        <div class="step-box">
          <ul>
            <li class="step-flex-top" v-for="(item, index) in stepList" :key="index">
              <span class="step-date">{{ item.date }}</span>
              <span class="step-week">{{ item.week }}</span>
              <ul>
                <li class="step-list" v-for="(sub, idx) in item.contextList" :key="idx">
                  <span class="step-time">{{ getShortTime(sub.time) }}</span>
                  <span class="step-text">{{ sub.context }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <span slot="title">
          <h4 class="dialog-title">物流详情</h4>
        </span>
        <span slot="footer">
          <el-button class="dialog-button" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/common/js/utils'
import PayDialog from '@/components/payDialog'
// import RefundDialog from '@/components/refundDialog'
import { config } from '@/constant/config'
import { loadList, getShippingList, getTransitStep } from '@/api/myOrder'


export default {
  name: 'retailOrderList',
  data () {
    return {
      tabPage: 0,
      orderList: [],
      total: null,
      listLoading: false,
      from: 'cart',
      navList: [
        { label: '全部订单', code: 'ALL' },
        { label: '待付款', code: 'UNPAY' },
        { label: '待发货', code: 'UNSEND' },
        { label: '待取货', code: 'UNTAKE' },
        { label: '待收货', code: 'UNUSE' },
        // { label: '待评价', code: 'UNCOMMET' },
        { label: '退款', code: 'REFUND' }
      ],
      listQuery: {
        limit: 10,
        page: 1
      },
      tableKey: 0,
      orderNo: null,
      orderNoDetail: null,
      orderDetailShow: false,
      stepList: [],
      dialogVisible: false
    }
  },
  created () {
    this.moduleType = 'RETAIL'
    this.loadList()
  },
  computed: {},
  components: {
    'payDialog': PayDialog
  },
  methods: {
    // 加载列表
    loadList () {
      const param = {
        tenantId: config.TENANTID,
        merchId: config.MERCHID,
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        status: this.navList[this.tabPage].code,
        orderCat: this.moduleType
      }
      loadList(param).then(response => {
        this.listLoading = false
        if (response.code === 0) {
          this.orderList = response.data.list.map((val) => {
            val.paymentTotal = Number(val.paymentTotal).toFixed(2)
            val.mainPic = null
            if (val.goodsPicture) {
              const pictures = JSON.parse(val.goodsPicture)
              val.mainPic = pictures.find(pic => pic.index === 1) && pictures.find(pic => pic.index === 1).url
            }
            return val
          })
          this.total = response.data.totalCount
        } else {
          this.$message.error('请求出错了')
        }
      })
    },
    handleTabPage (index) {
      this.tabPage = index
      this.page = 1
      this.loadList()
    },
    handleToPay (item) {
      if (this.flag) return
      this.flag = true
      let orderNo = '[' + item.uniteOrderNo + ']'
      this.$refs.payDialog.toPay(orderNo, item.orderCat)
    },
    // 点击收货处理
    handleToAfterSale () {
      this.$router.push({
        path: 'afterSalesOrderList',
        query: {
          moduleType: 'RETAIL'
        }
      })
    },
    getSelectTime () {
      this.date.forEach(item => {
        if (item.isCheck) {
          this.selectTime = item.selectTime || {}
          this.selectTime.showDate = item.showDate
        }
      })
    },
    handleToDetail (orderNo) {
      this.$router.push({ path: 'orderDetailNew', query: { orderNo, moduleType: this.moduleType } })
    },
    handleSizeChange (value) {
      this.listQuery.limit = value
      this.listQuery.page = 1
      this.loadList()
    },
    handleCurrentChange (value) {
      this.listQuery.page = value
      this.loadList()
    },
    // 支付
    hanleToPay (orderNo, item) {
      // 支付
      this.$router.push({
        path: 'payOrder',
        query: {
          orderNo
        }
      })
    },
    // 订单详情
    hanleToDetail (orderNo) {
      this.orderNoDetail = orderNo
      this.orderDetailShow = true
    },
    handleReset (formName) {
      this.$refs[formName].resetFields()
    },
    backAndClose () {
      this.orderDetailShow = false
    },
    getShortDate(date) {
      return formatDate('yyyy-MM-dd', new Date(date))
    },
    getShortTime(date) {
      return formatDate('hh:mm:ss', new Date(date))
    },
    getDateWeek (date) {
      const weekList = ["日", "一", "二", "三", "四", "五", "六"]
      const dd = new Date(date);
      const week = '周' + weekList[dd.getDay()]
      return week
    },
    // 查看物流
    handleToShipping(uniteOrderNo) {
      getShippingList(uniteOrderNo).then(res => {
        if (res.code === 0 && res.data.length > 0) {
          this.loadTransitStep(res.data[0])
        } else {
          this.$message.warning('未查询到物流信息')
        }
      })
    },
    loadTransitStep(data) {
      const param = {
        trackingNo: data.trackingNo,
				deliveryCorpCode: data.deliveryCorpCode
      }
      getTransitStep(param).then(res => {
        if (res.code === 0 && res.data.length > 0) {
          // 相同日期的项整合
          const arr = res.data
          let map = {}, dest = []
          for(let i = 0; i < arr.length; i++) {
            let ai = arr[i]
            const date = this.getShortDate(ai.time)
            const week = this.getDateWeek(ai.time)
            if (!map[date]) {
              dest.push({
                date,
                week,
                contextList: [ai]
              })
              map[date] = ai;
            } else {
              for(var j = 0; j < dest.length; j++){
                var dj = dest[j]
                if (dj.date == date) {
                  dj.contextList.push(ai)
                  break
                }
              }
            }
          }
          this.stepList = dest
          this.dialogVisible = true
        } else {
          this.$message.warning('未查询到物流信息')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.retail-order-list{
  padding: 60px 40px;
  border-radius: 8px;
  .nav-box {
    position: relative;
    .after-sale-btn {
      position: absolute;
      right: 0;
      top: 0;
      width: 112px;
      height: 36px;
      padding: 0;
      background: #9B232A;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 36px;
      color: #FFFFFF;
    }
  }
  .order-item{
    overflow-x: auto;
    padding: 30px 0;
    border-bottom: 1px solid #8fa8bc81;
    .pic {
      width: 231px;
    }
    .order-img{
      width: 207px;
      height: 130px;
      margin-right: 24px;
    }
    .order-item-info{
      flex: 1;
      height: 130px;
      .title-time {
        margin-bottom: 20px;
      }
      .order-title{
        display: inline-block;
        margin: 0;
        margin-right: 35px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #242B34;
        cursor: pointer;
        &:hover{
          color: #9B232A
        }
      }
      .lable{
        margin-right: 16px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9FA1B0;
      }
      .lable-value{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #424855;
      }

      .goods-name {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #242B34;
      }

      .num {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9FA1B0;
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #242B34;
        }
      }

      .order-pay{
        width: 280px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #424855;
      }

      .order-status {
        position: relative;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #424855;
      }
    }
    .order-btn {
      position: absolute;
      right: 0;
      transform: translateY(-30%);
      padding: 6px 16px;
      border: 1px solid #9B232A;
      border-radius: 4px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #9B232A;
      text-align: center;
      cursor: pointer;
      background-color: #FFFFFF;
    }
    .w120 {
      width: 120px;
    }
  }
}
.dialog-title {
  font-size: 28px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #9B232A;
  padding: 0;
  margin: 20px 0;
}
.dialog-button {
  width: 140px;
  height: 44px;
  background: #9B232A;
  border-radius: 4px;
  color: #FFFFFF;
  font-size: 16px;
  border: #9B232A 1px solid;
  margin-bottom: 20px;
}
.step-box {
  padding: 0 40px;
  .step-flex-top {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  .step-date {
    width: 130px;
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #242B34;
    line-height: 24px;
  }
  .step-week {
    width: 72px;
    font-size: 16px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #242B34;
    line-height: 24px;
  }
  .step-time {
    width: 100px;
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #242B34;
    line-height: 24px;
  }
  .step-text {
    width: 630px;
    font-size: 16px;
    line-height: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #242B34;
  }
  .step-list {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
}


</style>
